<template>
  <div>
    <a-card :bordered="false" class="citySelect-box">
      <template #title>
        <div class="flex items-center current-row">
          <span class="mr-3">当前：</span>
          <img src="@/assets/home/icon-location.png" class="icon-location mr-5" />
          <span class="current-city">{{ currentCity.district }}</span>
        </div>
      </template>
      <div class="">
        <a-list item-layout="horizontal" :data-source="cityList">
          <template #renderItem="{ item }">
            <a-list-item>
              <div
                class="mr-40 mt-12"
                v-for="(cityItem, index) in item.cityList"
                :key="cityItem.code"
                style="cursor: pointer"
                @click="selectCity(cityItem)">
                <div class="list-item-name">{{ cityItem.district }}</div>
                <div class="list-item-whole" v-if="item.code != 0">{{ item.district + cityItem.district }}</div>
              </div>
            </a-list-item>
          </template>
        </a-list>
      </div>
    </a-card>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import api from '@/net/api'
const store = useStore()
const emits = defineEmits(['changeCity'])
const currentCity = computed(() => store.state.city.currentCity)

const cityList = ref([])

onMounted(() => {
  getOpenDistrict()
})

// 获取开通区域
function getOpenDistrict() {
  api.get_plat_openDistrict().then(res => {
    if (res) {
      cityList.value = [
        {
          code: 0,
          district: '',
          cityList: [{ code: 0, district: '全国' }]
        },
        ...(res || [])
      ]
    }
  })
}
// 点击选择城市时
function selectCity(item) {
  emits('changeCity', item)
}


</script>
<style lang="scss" scoped>
.citySelect-box {
  width: 623px;
  height: 482px;
  overflow-y: auto;
  box-sizing: border-box;
  box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.16);
  font-size: 16px;
  font-weight: normal;

  :deep(.ant-card-body) {
    padding: 0 20px;
  }

  .current-row {
    color: #333333;
    font-weight: normal;

    .icon-location {
      width: 20px;
      height: 20px;
      font-family: MicrosoftYaHei;
    }

    .current-city {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #00cca0;
    }
  }

  .ant-list-item {
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0px 24px 12px;

    .list-item-name {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #333333;
    }

    .list-item-whole {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #999999;
    }
  }
}
</style>
